export const UserReducer = (state={}, action) => {
	switch (action.type)
	{
		case 'SET_USER':
			return {...action.payload};
		default:
			return state;
	}
}

export const PreferencesReducer = (state={}, action) => {
	switch (action.type)
	{
		case 'SET_PREFERENCES':
			return {...action.payload};
		default:
			return state;
	}
}